export const QUERY_BOOKING_REPORT_REQUEST = "QUERY_BOOKING_REPORT_REQUEST";
export const QUERY_BOOKING_REPORT_REQUEST_SUCCESS = "QUERY_BOOKING_REPORT_REQUEST_SUCCESS";
export const QUERY_BOOKING_REPORT_REQUEST_FAILURE = "QUERY_BOOKING_REPORT_REQUEST_FAILURE";
export const QUERY_BOOKING_REPORT_CLEANUP = "QUERY_BOOKING_REPORT_CLEANUP";
